// Campus photo for /colleges/elon-university: CC BY 4.0, by JERFDAN, from
// Wikimedia Commons (https://commons.wikimedia.org/wiki/File%3AAlamance_building.jpg), checked 2026-10-02 by
// scripts/college-photo.mjs (license allowlist, no restrictions, not a logo).
// Resized and self-hosted under public/colleges/elon-university/; credited under the photo.
const photo = {
    "slug": "elon-university",
    "alt": "The Alamance Building and its fountains on the main quad at Elon University in Elon, North Carolina",
    "src": "/colleges/elon-university/campus-1600.webp",
    "srcSmall": "/colleges/elon-university/campus-800.webp",
    "srcMid": "/colleges/elon-university/campus-1200.webp",
    "width": 1600,
    "height": 900,
    "og": "/colleges/elon-university/og.jpg",
    "title": "Alamance building",
    "author": "JERFDAN",
    "license": "CC BY 4.0",
    "licenseUrl": "https://creativecommons.org/licenses/by/4.0",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File%3AAlamance_building.jpg",
    "read": "2026-10-02"
};

export default photo;
